export enum FileType {
  Pdf = 0,
  Xlsx = 1,
  Docx = 2,
  Pptx = 3,
}
